import React from 'react'
import scholership from "../assets/images/scholership.jpg";
export default function Scholership() {
    return (
        <>
            <h4 className='p-4'>SCHOLERSHIP</h4>
            <div className='w-full  flex flex-col items-center justify-center bg-gray-100 p-6'>

                <div className='bg-white shadow-lg rounded-2xl p-6 max-w-lg text-center'>

                    <img src={scholership} alt='' className='w-[400px] h-[300px] ' />
                </div>
            </div>
        </>

    )
}
